import React, { useEffect, useState } from 'react';
import api from '../services/api';
import ProductCard from '../components/product/ProductCard';

export default function NewArrivalsPage() {
  const [products, setProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);

  useEffect(() => {
    setLoading(true);
    api.get('/products', { params: { is_new: 1, page, per_page: 20 } })
      .then(r => {
        setProducts(r.data.data || r.data);
        setLastPage(r.data.meta?.last_page || r.data.last_page || 1);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [page]);

  return (
    <div className="min-h-screen bg-white">
      <div className="bg-gray-900 py-16 text-center">
        <p className="text-xs font-medium uppercase tracking-[0.3em] text-gray-400 mb-3">Fresh Drops</p>
        <h1 className="text-4xl md:text-5xl font-serif font-bold text-white">New Arrivals</h1>
        <p className="text-gray-400 mt-3 text-sm">The latest baby wear additions — soft, stylish & comfortable</p>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-12">
        {loading ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {Array(12).fill(null).map((_, i) => (
              <div key={i} className="aspect-[3/4] bg-gray-100 animate-pulse rounded" />
            ))}
          </div>
        ) : (
          <>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
              {products.map(p => <ProductCard key={p.id} product={p} />)}
            </div>
            {lastPage > 1 && (
              <div className="flex justify-center gap-2 mt-10">
                {Array.from({ length: lastPage }, (_, i) => i + 1).map(p => (
                  <button key={p} onClick={() => setPage(p)} className={`w-10 h-10 text-sm font-medium border transition-colors ${p === page ? 'bg-gray-900 text-white border-gray-900' : 'border-gray-300 text-gray-700 hover:border-gray-900'}`}>{p}</button>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
